<div class="card">
  <div class="card-title">
    <h2>Prospect Summary by Sector</h2>
  </div>
  <div class="prospect-summary-container">
    <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
      <p-accordionTab header="Prospect Summary Table (by Sector)">
        <div class="group-cont">
          <div class="table-responsive">
            <p-table #dtProspectSummarySector
              class="table"
              styleClass="ui-table-products"
              tableStyleClass="table table-responsive"
              [value]="prospectSummary"
              [totalRecords]="prospectSummary.length"
              [rows]="10"
              [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10, 25, 50]"
              [paginator]="true"
              [resizableColumns]="true"
              (onFilter)="onTableFilter($event)"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

              <ng-template pTemplate="caption">
                <div style="text-align: right">
                  <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                    (click)="exportProspectSummaryExcel()" style="margin-top: 0.5em;margin-right: 0.5em;"
                    class="ui-button-success"></button>
                  <button type="button" pButton icon="pi pi-file-pdf" iconPos="left"
                    (click)="exportProspectSummaryPdf()" label="PDF" class="ui-button-warning"
                    style="margin-top: 0.5em;"></button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th>#</th>
                  <th pSortableColumn="sectorName" width="20%">Sector Name
                    <p-sortIcon field="sectorName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="status" width="20%">Status
                    <p-sortIcon field="status"></p-sortIcon>
                  </th>
                  <th pSortableColumn="prospectCount" width="20%">Prospect Count
                    <p-sortIcon field="prospectCount"></p-sortIcon>
                  </th>
                  <th pSortableColumn="totalActivities" width="20%">Total Activities
                    <p-sortIcon field="totalActivities"></p-sortIcon>
                  </th>
                  <th pSortableColumn="totalServiceValue" width="20%">Total Service Value
                    <p-sortIcon field="totalServiceValue"></p-sortIcon>
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th>
                    <p-columnFilter field="sectorName" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" [showMenu]="true">
                      <ng-template pTemplate="filter" let-filter="filterCallback">
                        <p-multiSelect [options]="sectorNameOptions" placeholder="Select Sector(s)"
                          (onChange)="filter($event.value)" optionLabel="label" optionValue="value" display="chip"
                          [filter]="true">
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </th>
                  <th>
                    <p-columnFilter field="status" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" [showMenu]="true">
                      <ng-template pTemplate="filter" let-filter="filterCallback">
                        <p-multiSelect [options]="statusOptions" placeholder="Select Status(es)"
                          (onChange)="filter($event.value)" optionLabel="label" optionValue="value" display="chip"
                          [filter]="true">
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </th>
                  <th><p-columnFilter field="prospectCount" type="numeric" display="menu"></p-columnFilter></th>
                  <th><p-columnFilter field="totalActivities" type="numeric" display="menu"></p-columnFilter></th>
                  <th><p-columnFilter field="totalServiceValue" type="numeric" display="menu"></p-columnFilter></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-summary let-i="rowIndex">
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ summary.sectorName }}</td>
                  <td>{{ summary.status }}</td>
                  <td>{{ summary.prospectCount }}</td>
                  <td>{{ summary.totalActivities }}</td>
                  <td>${{ summary.totalServiceValue | number:'1.0-0' }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>

  <!-- Chart Section -->
  <div class="card">
    <div class="card-title">
      <h2>Prospect Summary Chart (by Sector)</h2>
    </div>
    <div class="cont" id="chart-Container">
      <div class="p-grid" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
        <div class="p-col" style="flex: 1; padding: 0 5px;">
          <label for="groupBy">Group By:</label>
          <p-dropdown id="groupBy" [options]="prospectSummaryGroupByOptions"
            [(ngModel)]="selectedProspectSummaryGroupBy" (onChange)="onProspectSummaryGroupByChange()"
            optionLabel="label" optionValue="value">
          </p-dropdown>
        </div>
        <div class="p-col" style="flex: 1; padding: 0 5px;">
          <label for="dataType">Data Type:</label>
          <p-dropdown id="dataType" [options]="prospectSummaryDataTypes"
            [(ngModel)]="selectedProspectSummaryDataType" (onChange)="onProspectSummaryDataTypeChange()"
            optionLabel="label" optionValue="value">
          </p-dropdown>
        </div>
        <div class="p-col" style="flex: 1; padding: 0 5px;">
          <label for="sectorScope">Show:</label>
          <p-dropdown id="sectorScope" [options]="sectorScopeOptions"
            [(ngModel)]="selectedSectorScope" (onChange)="onSectorScopeChange()" optionLabel="label"
            optionValue="value">
          </p-dropdown>
        </div>
        <div class="p-col" style="flex: 1; padding: 0 5px;">
          <label for="sectorCount">Count:</label>
          <p-inputNumber id="sectorCount" [(ngModel)]="selectedSectorCount"
            (onInput)="onSectorCountChange()" [disabled]="selectedSectorScope === 'all'" [min]="1"
            [showButtons]="true" [useGrouping]="false" styleClass="w-full">
          </p-inputNumber>
        </div>
        <div class="p-col" style="flex: 1; padding: 0 5px;">
          <label for="yearSelect">Year(s):</label>
          <p-multiSelect id="yearSelect" [options]="yearOptions" [(ngModel)]="selectedYears"
            (onChange)="onYearSelectionChange()" optionLabel="label" optionValue="value" placeholder="Select Year(s)"
            display="comma" [showSelectAll]="true" [filter]="true" styleClass="w-full">
          </p-multiSelect>
        </div>
        <div class="p-col" style="flex: 1; padding-top: 15px;">
          <button pButton type="button" [label]="isSorted ? 'Sorted' : 'Sort'"
            [icon]="isSorted ? 'pi pi-sort-amount-down' : 'pi pi-sort'" (click)="onSortToggle()"
            class="p-button-secondary" style="width: 100%;">
          </button>
        </div>
      </div>

      <div class="chart-container">
        <div class="chart-wrapper">
          <p-chart #prospectSummarySectorChart type="bar" [data]="prospectSummaryChartData"
            [options]="prospectSummaryChartOptions" height="400px" class="prospect-chart">
          </p-chart>
        </div>
        <div class="custom-legend-container" *ngIf="prospectSummaryChartData?.datasets?.length">
          <h4 class="legend-title">Legend</h4>
          <div class="legend-items-container">
            <div *ngFor="let dataset of prospectSummaryChartData.datasets; let i = index" class="legend-item"
              [class.legend-item-hidden]="isDatasetHidden(i)" (click)="toggleDataset(i)">
              <span class="legend-color-box" [style.background-color]="dataset.backgroundColor"
                [style.opacity]="isDatasetHidden(i) ? 0.4 : 1"></span>
              <span class="legend-label"
                [style.text-decoration]="isDatasetHidden(i) ? 'line-through' : 'none'">{{ dataset.label }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-buttons">
        <button type="button" (click)="exportProspectSummaryChartAsImage()" class="ui-button-success export-button"
          style="margin-top: 1em;">Export Chart as PNG</button>
        <button type="button" (click)="exportProspectSummaryChartAsPDF()" class="ui-button-success export-button"
          style="margin-top: 1em;">Export Chart as PDF</button>
      </div>
    </div>
  </div>
</div>